import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import accepts from 'attr-accept'
import _ from 'lodash'

import ImageCrop from './ImageCrop'

const DroppableDiv = styled.div`
  position: relative;
  flex: 1 0 100px;
  display: flex;
  flex-direction: column;
`
const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: ${props => props.visible ? 'flex' : 'none'};
  background: rgba(234, 247, 255, 0.85);
  z-index: 1;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`

function fileAccepted (file, filetypes) {
  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
  // that MIME type will always be accepted
  return file.type === 'application/x-moz-file' || accepts(file, filetypes)
}

class Droppable extends Component {

  dragCounter = 0

  constructor (props) {
    super(props)

    this.state = {
      draggedOver: false,
      file: null
    }
  }

  onCropComplete = (file) => {
    this.setState({file: null})
    if (!_.isNil(file)) this.props.onDropAccepted(file)
  }

  renderCropModal = () => {
    const { file } = this.state
    if (!_.isNil(file)) {
      return (
        <ImageCrop
          file={file}
          onComplete={this.onCropComplete}
        />
      )
    }
  }

  render () {
    return (
      <DroppableDiv
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        onDragOver={e => e.preventDefault()}
        onDrop={this.onDrop}
      >
        <Overlay visible={this.state.draggedOver}>
          {this.props.dragOverlay}
        </Overlay>
        {this.state.draggedOver ? null : this.props.children}
        {this.renderCropModal()}
      </DroppableDiv>
    )
  }

  onDragEnter = (e) => {
    if (this.dragCounter === 0) {
      this.setState({draggedOver: true})
    }
    this.dragCounter += 1
  }

  onDragLeave = (e) => {
    this.dragCounter -= 1
    if (this.dragCounter === 0) {
      this.setState({draggedOver: false})
    }
  }

  onDrop = (e) => {
    const { needsCrop, onDropAccepted, onDropRejected } = this.props
    e.preventDefault()
    this.dragCounter = 0
    this.setState({draggedOver: false})

    let files = e.dataTransfer.files
    const file = files[0]
    if (file && fileAccepted(file, this.props.filetypes)) {
      if (needsCrop) {
        this.setState({ file: file })
      } else {
        onDropAccepted(file)
      }
    } else {
      onDropRejected(file)
    }

    // for (let i = 0; i < files.length; ++i) {
    //   if (fileAccepted(files[i], this.props.filetypes)) {
    //     this.props.onDropAccepted(files[i])
    //   } else {
    //     this.props.onDropRejected(files[i])
    //   }
    // }
  }
}

Droppable.defaultProps = {
  needsCrop: true
}

Droppable.propTypes = {
  dragOverlay: PropTypes.element,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  filetypes: PropTypes.string,
  needsCrop: PropTypes.bool
}

export default Droppable



// WEBPACK FOOTER //
// ./src/components/editor/assetsManager/Droppable.js